module.exports = __webpack_public_path__ + "img/step5-c.1601f26f.png";